define('ImagesSorting', [
    'ItemKeyMapping.ImagesSorting',
    'Product.Model.ImagesSorting'
],
function ImagesSorting(
) {
    'use strict';

    return {};
});

